var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDogear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08134 0.00195312L11.5244 5.42189V15.9953L3.2234 16.002C2.3691 16.0016 1.54985 15.6623 0.945503 15.0585C0.341154 14.4547 0.00110236 13.6357 0 12.7814V0.0118263L6.08134 0.00195312ZM9.89255 6.09986L5.40851 1.63499L1.6319 1.64111V12.7814C1.63237 13.2026 1.79989 13.6064 2.0977 13.9042C2.39551 14.202 2.79929 14.3696 3.22046 14.3701L9.89239 14.3647L9.89255 6.09986Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogear);
export default __webpack_public_path__ + "static/media/dogear.c2e16aa72f77f3d33eba5ac9aa4e48e2.svg";
export { ForwardRef as ReactComponent };